import api from 'helpers/api';
import { normalizeGroupDetail, TWireGroupDetail } from 'helpers/story';
import API_ENDPOINT from 'constants/apiEndpoint';
import { TApiResult, TPagedResponse } from 'types/common';
import { TCreateGroupBody, TGroupDetail, TPlacement, TUpdateGroupBody } from 'types/story';

type TGetGroupsParams = {
  placement: TPlacement;
  page: number;
  size: number;
  sortBy?: string;
  isAscending?: boolean;
};

export const getGroups = ({
  placement,
  page,
  size,
  sortBy,
  isAscending,
}: TGetGroupsParams): Promise<TPagedResponse<TGroupDetail>> =>
  api
    .get<TApiResult<TPagedResponse<TWireGroupDetail>>>(API_ENDPOINT.story.groups, {
      params: { placement, page, size, sortBy, isAscending },
    })
    .then((r) => ({ ...r.result, content: (r.result.content ?? []).map(normalizeGroupDetail) }));

export const getGroup = (id: string): Promise<TGroupDetail> =>
  api
    .get<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.group(id))
    .then((r) => normalizeGroupDetail(r.result));

export const createGroup = (body: TCreateGroupBody): Promise<TGroupDetail> =>
  api
    .post<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.groups, body)
    .then((r) => normalizeGroupDetail(r.result));

export const updateGroup = (id: string, body: TUpdateGroupBody): Promise<TGroupDetail> =>
  api
    .put<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.group(id), body)
    .then((r) => normalizeGroupDetail(r.result));

export const publishGroup = (id: string): Promise<TGroupDetail> =>
  api
    .put<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.publish(id))
    .then((r) => normalizeGroupDetail(r.result));

export const disableGroup = (id: string): Promise<TGroupDetail> =>
  api
    .put<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.disable(id))
    .then((r) => normalizeGroupDetail(r.result));

export const activateGroup = (id: string): Promise<TGroupDetail> =>
  api
    .put<TApiResult<TWireGroupDetail>>(API_ENDPOINT.story.activate(id))
    .then((r) => normalizeGroupDetail(r.result));

export const deleteGroup = (id: string): Promise<void> =>
  api.delete<void>(API_ENDPOINT.story.group(id));
